<template>

	<div class="form-group required">
		<label :for="id">
			<slot name="label">
				<!-- Input label text here-->
			</slot>

		</label>
		<input
				:value="value"
			    :class="validationClasses"

				class="form-control"

				:disabled="disabled"
				:id="id"
				:placeholder="placeholder"
				:spellcheck="spellcheck"

				@input="updateValue"
				@change="updateValue"
				@blur="$emit('blur')"
				@focus="focus"
				data-vv-delay="500"
		>
		<div v-if="invalid" class="invalid-feedback">
			{{ error.first(path) }}
		</div>
		<slot name="validate">
			<!--Some outer validation here-->
		</slot>
	</div>


</template>
<script>



	export default {
		name: 'vee-input',
		$_veeValidate: {
			// value getter
			value () {
				return this.value;
			},
			// name getter
			name () {
				return this.name;
			}
		},
		computed: {
			/*flags(){

			},*/

			fieldsP(){
				//Get parent fields to reduce outside required properties
				return this.$parent.fields
			},
			error(){
				//Get parent error bag to reduce outside required properties
				return this.$parent.errors
			},
			path(){
				//Build string path
				if(typeof this.scope !== 'undefined'){
					return `${this.scope}.${this.name}`;
				}else{
					return this.name;
				}
			},
			validationClasses(){
				return [
					this.invalid ? 'is-invalid' : '',
					this.valid ? 'is-valid' : ''
				];
			},
			valid(){
				//Check if field is valid
				return this.vali(this.path, this.error, true)
			},
			invalid(){

				return this.vali(this.path, this.error, false)
			}
		},
		props: {
			value: String,
			placeholder: String,
			scope: String,
			name: String,
			id: {
				type: String,
				default(){
					return this.name+'-'+localRandomString();
				}
			},
			disabled: {
				type: Boolean,
				default: false
			},
			spellcheck: {
				type: Boolean,
				default: true
			},
			type: {
				type: String,
				default: 'text',
				validate: (val) => {
					// we only cover these types in our input components.
					return ['text', 'url', 'email', 'password', 'search'].indexOf(val) !== -1;
				}
			}
		},
		watch:{
			/*'$parent.errors':{
				handler(val){
					//console.log(val)
					//this.errors = val;
				},
				deep: true
			}*/
		},

		mounted(){
			/*console.log(this);*/
		},
		methods: {
			focus(){
				//Remove custom error from bag
				this.error.removeById(this.path);
				this.$emit('focus');
			},

			updateValue(e) {
				this.$emit('input', e.target.value)
			},

			//Helper functions
			vali(path, er,  isValid){
				let p = path.split('.');
				let scope = null;
				let name = p[0];

				//Check if path contain scope
				if (p.length > 1) {
					scope = p[0];
					name = p[1];
				}

				//Get given field flags properties
				let flags;

				if (scope) {
					if (!this.fieldsP['$' + scope]) {
						//Field not found or still not created, break
						return false;
					}
					flags = this.fieldsP['$' + scope][name];
				} else {
					flags = this.fieldsP[name];

				}


				if (!flags) {
					return false;
				} else {

					//Check if we want to know if field valid or invalid
					return isValid
						?
						flags.valid && flags.touched // valid:true/false
						:
						/*flags.invalid &&*/ er.has(path);  // inValid:true/false
				}
			}
		}

	}

	function localRandomString() {
		function s4() {
			return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
		}
		return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
	}
</script>
<style>

</style>